import { Box, BoxProps } from "@mui/material";
import React from "react";

export const NoPropagateBox = ({
  children,
  onKeyDown,
  onMouseDown,
  onTouchStart,
  onClick,
  ...props
}: React.PropsWithChildren<BoxProps>) => {
  return (
    <Box
      onMouseDown={e => {
        e.stopPropagation();
        onMouseDown?.(e);
      }}
      onTouchStart={e => {
        e.stopPropagation();
        onTouchStart?.(e);
      }}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        onClick?.(e);
      }}
      onKeyDown={e => {
        if (e.key === "Tab") {
          return;
        }
        e.stopPropagation();
        onKeyDown?.(e);
      }}
      {...props}
    >
      {children}
    </Box>
  );
};
